<div 
 class="fr-animatedIcon-wrapper" 
 [ngClass]="isExpanded ? 'fr-animatedIcon--expanded' : 'fr-animatedIcon--collapsed'"
 >
  <span class="fr-animatedIcon-line fr-animatedIcon-line1"></span>
  <span class="fr-animatedIcon-line fr-animatedIcon-line2"></span>
  <span class="fr-animatedIcon-line fr-animatedIcon-line3"></span>
</div>

